import { useTheme } from '@/themes';
import { ZopaFooter } from '@zopauk/react-components';
import { MainCobrandedLegalCopy } from '@/pages/cancelled';

// TODO: This Component is causing a hydration error

export function Footer() {
  const { isCobranded, copy } = useTheme();

  return (
    <ZopaFooter
      mainCustomLegalCopy={!isCobranded ? copy.footer?.mainCustomLegalCopy : undefined}
      customFooterLinks={!isCobranded ? copy.footer?.customFooterLinks : undefined}
      mainCobrandedLegalCopy={isCobranded ? <MainCobrandedLegalCopy /> : null}
      isCobranded={isCobranded}
    />
  );
}
